/* app/js/src/components/common/libraryWrapper/libraryWrapper.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.activeItem,
aside .tabs ul li.active,
aside .tabs ul li:hover {
  color: #232f3a;
}
.activeItem svg,
aside .tabs ul li.active svg,
aside .tabs ul li:hover svg {
  fill: #232f3a;
}
aside {
  max-width: 380px;
  width: 380px;
  position: relative;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -ms-transform: translateX(0);
  -webkit-transform: translateX(0);
  transform: translateX(0);
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
aside .tabs {
  width: 75px;
  background-color: #ffffff;
}
aside .tabs ul {
  padding: 0;
  margin: 0;
}
aside .tabs ul li {
  height: 75px;
  text-align: center;
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: 600;
  color: #879baf;
  cursor: pointer;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
aside .tabs ul li i,
aside .tabs ul li span {
  display: block;
}
aside .tabs ul li svg {
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  fill: #879baf;
}
aside .tabs ul li span {
  margin-top: 5px;
}
aside .tabs ul li::after {
  content: " ";
}
aside .tabs ul li.active {
  background-color: #eef2f6;
}
aside section {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  padding: 15px 6px 15px 15px;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  overflow: hidden;
  position: relative;
}
aside.collapsed {
  -ms-transform: translateX(calc(-100% + 5px));
  -webkit-transform: translateX(calc(-100% + 5px));
  transform: translateX(calc(-100% + 5px));
}
/*# sourceMappingURL=libraryWrapper.component.css.map */
